var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"checkout-button",class:_vm.optionId === _vm.activeOption
      ? 'checkout-button--active'
      : 'checkout-button--inactive',on:{"click":_vm.onButtonClick}},[_c('span',{staticClass:"checkout-button__label"},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }